module.exports = __webpack_public_path__ + "img/hotelLogo.4be8a70e.png";